import Vue from "vue";
import VueCookies from "vue-cookies";
import { globalEnv } from "fe-infrastractures";

Vue.use(VueCookies);
Vue.$cookies.config(globalEnv.VUE_APP_EXPIRES, null, null, null, "Lax");
